import moment from 'moment';
import '../lib/daterangepicker.js';

class DatePickerController {
  constructor(
    $scope,
    RouterService,
    $rootScope,
    PermissionService,
    $cookies,
    $timeout,
  ) {
    const DP_LOCALES = {
      'ru': {
        applyLabel: 'ОК',
        cancelLabel: 'Отмена',
        fromLabel: 'С',
        toLabel: 'по',
        weekLabel: 'нед',
        format: 'DD/MM/YYYY',
      },
      'en': {},
    };

    this.loaded = false;

    this.PermissionService = PermissionService;
    this.notFreezeWeb = !this.PermissionService.freeze_default_web_interface;

    $rootScope.$on('init', () => {
      this.notFreezeWeb = !this.PermissionService.freeze_default_web_interface;
      const selectedLang = $cookies.get('django_language') || this.PermissionService.selectedLang || this.PermissionService.defaultLang;
      const dp_locale = DP_LOCALES[selectedLang] ? DP_LOCALES[selectedLang] : DP_LOCALES['en'];
      if (!this.notFreezeWeb) return;
      this.picker = $('#reportrange').daterangepicker({
          startDate: moment(this.timeFrom),
          endDate: moment(this.timeTo),
          minDate: moment().year(2000),
          // dateLimit          : {days: 365},
          showDropdowns: false,
          showWeekNumbers: true,
          timePicker: true,
          timePickerIncrement: 1,
          timePicker24Hour: true,
          ranges: this.ranges,
          opens: 'right',
          drops: 'down',
          alwaysShowCalendars: true,
          linkedCalendars: true,
          buttonClasses: ['btn', 'btn-lg'],
          separator: ' to ',
          timeZone: 0,
          locale: dp_locale,
          autoApply: true,
          selectedLang: selectedLang,
        }, (start, end, label) => {
          this.timeFrom = start.toDate();
          RouterService.timeFrom = this.timeFrom;
          this.timeTo = end.toDate();
          RouterService.timeTo = this.timeTo;
          $rootScope.$digest();
        })
        .data('daterangepicker');
      this.loaded = true;
    });

    $scope.$watch('$ctrl.timeFrom', (newValue) => {
      if (this.picker) this.picker.setStartDate(newValue);
    });
    $scope.$watch('$ctrl.timeTo', (newValue) => {
      if (this.picker) this.picker.setEndDate(newValue);
    });

  }

  get ranges() {
    return {
      'Сегодня': [moment().startOf('day'), moment().endOf('day')],
      'Вчера': [
        moment().startOf('day').subtract(1, 'days'), moment()
        .endOf('day')
        .subtract(1, 'days'),
      ],
      '7 дней': [
        moment().startOf('day').subtract(6, 'days'), moment()
        .endOf('day'),
      ],
      '30 дней': [
        moment()
        .startOf('day')
        .subtract(29, 'days'), moment()
        .endOf('day'),
      ],
      'Текущая неделя': [moment().startOf('week'), moment().endOf('week')],
      'Текущий месяц': [moment().startOf('month'), moment().endOf('month')],
      'Текущий год': [moment().startOf('year'), moment().endOf('year')],
    };
  }

  setInitRanges() {
    if (this.picker && this.PermissionService.selectedLang === 'ru')
      this.picker.ranges = this.ranges;
  }
}

export const DatePickerComponent = {
  template: require('./date-picker.component.html'),
  controller: DatePickerController,
  bindings: {
    timeFrom: '=',
    timeTo: '=',
  },
};



// WEBPACK FOOTER //
// ./src/filter/date-picker.component.js